// The band's instruments as the mixer and the Style panel's sections label them.
import type { BassSound, LeadSound } from '@/audio/instrumentSamples';
import type { CompInstrument } from '@/music/style';

export const LEAD_SOUNDS: readonly { id: LeadSound; label: string }[] = [
  { id: 'tenor-sax', label: 'Tenor' },
  { id: 'trumpet', label: 'Trumpet' },
  { id: 'piano', label: 'Piano' },
  { id: 'guitar', label: 'Guitar' },
];
export const COMP_SOUNDS: readonly { id: CompInstrument; label: string }[] = [
  { id: 'piano', label: 'Piano' },
  { id: 'piano-left', label: 'LH piano' },
  { id: 'guitar', label: 'Guitar' },
];
export const BASS_SOUNDS: readonly { id: BassSound; label: string }[] = [
  { id: 'upright', label: 'Upright' },
  { id: 'electric', label: 'Electric' },
  { id: 'original', label: 'Synth' },
];

/** How the comp instrument reads beside a band's name. */
export function compSoundLabel(instrument: CompInstrument): string {
  return COMP_SOUNDS.find((sound) => sound.id === instrument)?.label ?? instrument;
}
